export const DS_URL_FIELD_CLASSES = {
  Root: "ds-url-field",
  Readonly: "ds-url-field--readonly",
} as const;
